import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary py-2 bg-gradient text-light" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  style: {"--bs-breadcrumb-divider":"url(\n                  \"data:image/svg + xml,\n                  %3Csvgxmlns='http://www.w3.org/2000/svg'width='8'height='8'%3E%3Cpathd='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z'fill='%236c757d'/%3E%3C/svg%3E\"\n                )"},
  "aria-label": "breadcrumb"
}
const _hoisted_7 = { class: "breadcrumb" }
const _hoisted_8 = ["aria-current"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "row mb-3 gap-3 px-3" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "btn-content" }
const _hoisted_14 = { class: "m-0 btn-name" }
const _hoisted_15 = {
  key: 0,
  class: "my-3"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "btn-content" }
const _hoisted_18 = { class: "m-0 btn-name" }
const _hoisted_19 = { class: "btn-image" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "img-container" }
const _hoisted_22 = {
  class: "",
  style: {"height":"350px","max-height":"350px"},
  ref: "imageWorkArea"
}
const _hoisted_23 = { class: "modal-footer" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "d-flex justify-content-end" }
const _hoisted_26 = {
  key: 0,
  type: "button",
  class: "btn btn-outline-secondary mx-2 order-1",
  disabled: ""
}
const _hoisted_27 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-4 align-items-start mb-2" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { class: "col-8 col-md-4 d-flex justify-content-end justify-content-md-center mb-2" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "col-12 col-md-4 d-flex justify-content-end mb-2" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "fas fa-spinner fa-spin fa-fw me-1"
}
const _hoisted_37 = {
  key: 1,
  class: "fas fa-save fa-fw me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "button", { onClick: _ctx.openModal }, undefined, true),
    _createElementVNode("div", {
      class: "modal",
      tabindex: "-1",
      id: `#modal-${_ctx.classId}-class-image`,
      ref: "classModalImageUpload"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "modal-title" }, [
              _createElementVNode("i", { class: "fas fa-camera fa-fw me-2" }),
              _createTextVNode(" Modificar imagen de clase ")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close btn-sm btn-close-white",
              "aria-label": "Close",
              ref: "close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("section", null, [
              _createElementVNode("nav", _hoisted_6, [
                _createElementVNode("ol", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumb, (page, ind) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: ind }, [
                      (!_ctx.breadcrumbAvoid.includes(page))
                        ? (_openBlock(), _createElementBlock("li", {
                            key: 0,
                            class: _normalizeClass(["breadcrumb-item", 
                      ind == (_ctx.breadcrumb?.length ?? 0) - 1 ? 'active' : ''
                    ]),
                            "aria-current": 
                      ind == (_ctx.breadcrumb?.length ?? 0) - 1 ? 'page' : undefined
                    
                          }, [
                            (ind == (_ctx.breadcrumb?.length ?? 0) - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(page), 1))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: "#",
                                  onClick: ($event: any) => (_ctx.openFolder(_ctx.getPath(page)))
                                }, _toDisplayString(page), 9, _hoisted_10))
                          ], 10, _hoisted_8))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.folders, (folder) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: folder.fullPath,
                    class: "col-3 p-0 btn-container"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-items profile-image h-100 align-items-center w-100",
                      onClick: ($event: any) => (_ctx.openFolder(folder.fullPath))
                    }, [
                      _createElementVNode("div", _hoisted_13, [
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "btn-icon" }, [
                          _createElementVNode("i", { class: "fas fa-folder" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(folder.name), 1)
                      ])
                    ], 8, _hoisted_12)
                  ]))
                }), 128)),
                (_ctx.folders.length > 0 && _ctx.defaultImages.length > 0)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_15))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultImages, (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: image.fullPath,
                    class: "col-3 p-0 btn-container"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-items profile-image h-100 align-items-center w-100",
                      onClick: ($event: any) => (_ctx.saveProfilePicture(image.url))
                    }, [
                      _createElementVNode("div", _hoisted_17, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "btn-icon" }, [
                          _createElementVNode("i", { class: "fas fa-folder" })
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(image.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("img", {
                          src: image.url,
                          alt: image.fullPath,
                          class: "rounded ratio ratio-1x1"
                        }, null, 8, _hoisted_20)
                      ])
                    ], 8, _hoisted_16)
                  ]))
                }), 128))
              ])
            ], 512), [
              [_vShow, !_ctx.modeCrop]
            ]),
            _withDirectives(_createElementVNode("section", null, [
              _createElementVNode("input", {
                type: "file",
                class: "d-none",
                id: "uploaded-image",
                accept: "image/png,image/jpeg,image/jpg",
                ref: "uploadedImage",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadImage($event)))
              }, null, 544),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, null, 512)
              ])
            ], 512), [
              [_vShow, _ctx.modeCrop]
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            (!_ctx.modeCrop)
              ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectPictureFile())),
                      class: "btn btn-secondary"
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("i", {
                        class: "fa fa-upload me-2",
                        "aria-hidden": "true"
                      }, null, -1),
                      _createElementVNode("span", null, "Subir foto", -1)
                    ]))]),
                    (_ctx.saving)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_26, [...(_cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fas fa-spinner fa-spin fa-fw me-1" }, null, -1),
                          _createTextVNode(" Actualizando ", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-outline-primary mx-2 order-1",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                        }, " Cerrar "))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelCrop())),
                        disabled: _ctx.saving
                      }, [...(_cache[13] || (_cache[13] = [
                        _createElementVNode("i", { class: "far fa-arrow-alt-circle-left fa-fw me-1" }, null, -1),
                        _createTextVNode("Regresar ", -1)
                      ]))], 8, _hoisted_30)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-secondary",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectPictureFile())),
                        disabled: _ctx.saving
                      }, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("i", {
                          class: "fa fa-upload me-2",
                          "aria-hidden": "true"
                        }, null, -1),
                        _createTextVNode("Subir otro archivo ", -1)
                      ]))], 8, _hoisted_32)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-danger me-2",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closeModal())),
                        disabled: _ctx.saving
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "fas fa-ban fa-fw me-1" }, null, -1),
                        _createTextVNode("Cancelar ", -1)
                      ]))], 8, _hoisted_34),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-outline-success",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.saveProfilePicture())),
                        disabled: _ctx.saving
                      }, [
                        (_ctx.saving)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                          : (_openBlock(), _createElementBlock("i", _hoisted_37)),
                        _cache[16] || (_cache[16] = _createTextVNode("Aceptar ", -1))
                      ], 8, _hoisted_35)
                    ])
                  ])
                ]))
          ])
        ])
      ])
    ], 8, _hoisted_1)
  ], 64))
}